import { connect } from 'react-redux';
import { nodeIssues as nodeIssueSelectors } from '../selectors';
import { nodeIssuesReducer } from '../reducers';
import { nodeIssues as nodeIssueActions } from '../actions';
import NodeHealthDetailsComponent from '../Components/NodeHealthDetailsComponent';

export const mapStateToProps = (state) => {
  const props = {
    issueTypesById: nodeIssuesReducer.nodeIssueTypesById(state),
    selectedNodeIssues: nodeIssueSelectors.getSelectedNodeIssues(state),
    actionsById: nodeIssueSelectors.getNodeHealthActionsById(state),
    jobLinksById: nodeIssueSelectors.getNodeHealthIssueJobLinksById(state),
    selectedNodeIssuesForAck: nodeIssueSelectors.getNodeIssuesSelectedForAck(state),
  };
  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onAckSingle: (id) => dispatch(nodeIssueActions.markSingleInactive(id)),
    onAckMultiple: (ids) => dispatch(nodeIssueActions.markMultipleInactive(ids)),
    onActionButtonClick: (buttonAction) => dispatch(buttonAction),
    onSelectionComplete: (selected) => {
      dispatch(nodeIssueActions.setNodeIssuesSelectedForAck(selected));
    }
  };
};

const NodeHealthDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NodeHealthDetailsComponent);

export default NodeHealthDetailsContainer;


// WEBPACK FOOTER //
// src/Containers/NodeHealthDetailsContainer.jsx